
<template>
  <div class="airline_select">
    <DomesticTicketAirlineSelector v-model="code"/>
  </div>
</template>
<script>
import DomesticTicketAirlineSelector from "yinzhilv-js-sdk/frontend/common-project/component/yinzhilv/domestic-ticket-airline-selector/1.0.0/index.vue";
export default {
  data() {
    return {
      code: null,
    };
  },
  methods: {},
  watch: {
    code(val) {
      val ? this.$emit("input", val.airlineCode) : this.$emit("input", "");
    }
  },

  components: { DomesticTicketAirlineSelector }
};
</script>
<style lang="less" scoped>
.airline_select {
  display: inline-block;
  position: relative;
  /deep/.panel-filter-entity {
    position: absolute;
    z-index: 9999;
  }
}
</style>